import React from "react";
import PropTypes from "prop-types"
import {Link} from "gatsby";
import Emoji from "./emoji";

const CookieConsent = (props) => {
  return (
    <div className={`fixed bottom-0 w-full bg-black bg-opacity-80 backdrop-filter backdrop-blur-sm text-white
                    px-6 pt-2 pb-4 flex flex-col sm:flex-row justify-between
                    transition-transform ${props.hidden ? 'transform translate-y-full' : ''}`}>
      <div>
        <h1 className="text-3xl my-2">Cookies <Emoji emoji="🍪"/></h1>
        <p className="text-base">
          We use cookies on our websites to collect <strong>anonymous</strong> usage data.
          Learn more about our use of cookies in our <Link to="/privacy">Privacy Policy</Link>.
        </p>
      </div>
      <div className="flex flex-row-reverse sm:flex-col xl:flex-row justify-end items-end">
        <button className="ml-2 sm:ml-0 xl:mr-2 sm:mb-2 xl:mb-0 py-2 w-72 text-base font-normal"
                disabled={props.hidden}
                onClick={props.onAccept}>
          Accept
        </button>
        <button className="w-72 text-base py-2"
                disabled={props.hidden}
                onClick={props.onDecline}>
          Reject non-essential
        </button>
      </div>
    </div>
  )
}

CookieConsent.propTypes = {
  hidden: PropTypes.bool.isRequired,
  onAccept: PropTypes.func,
  onDecline: PropTypes.func
}

CookieConsent.defaultProps = {
  onAccept: () => console.log('Cookies accepted!'),
  onDecline: () => console.log('Cookies declined!')
}

export default CookieConsent
